import {gql} from '@apollo/client';

export const HOME_PAGE_QUERY = gql`
    query homePage($sitename: String, $homeId: String, $preview: Boolean) {
        categoryCollection(
            where: {parentId: $homeId, partition_not: true}
            preview: $preview
        ) {
            items {
                path
                name
                overview
                partition
                image {
                    title
                    description
                    url
                }
            }
        }
        homeCollection(where: {site: $sitename}, preview: $preview, limit: 1) {
            items {
                headline
                introduction
                metaTitle
                metaDescription
                slideshowCollection {
                    items {
                        path
                        title: metaTitle
                        heroFile {
                            url
                            title
                        }
                        overview
                        parent {
                            name
                            path
                        }
                    }
                }
                featuredArticlesTitle
                featuredArticlesCollection {
                    items {
                        path
                        headline
                        heroFile {
                            url
                            title
                        }
                        overview
                        parent {
                            name
                            path
                        }
                    }
                }
                callOutsCollection {
                    items {
                        __typename
                        ... on Category {
                            title: headline
                            path
                            overview
                            image {
                                title
                                description
                                url
                            }
                        }
                        ... on Article {
                            title: headline
                            path
                            overview
                            image: heroFile {
                                title
                                description
                                url
                            }
                            parent {
                                name
                                path
                            }
                        }
                    }
                }
                externalLinkCarousel {
                    title
                    externalLinksCollection {
                        items {
                            title
                            details
                            link
                            image {
                                title
                                description
                                url
                            }
                        }
                    }
                }
                hreflang
            }
        }
    }
`;
